// Scroll-triggered background for the sticky site header.
// A 1px sentinel at top of <body> toggles .is-scrolled on .site-header
// via IntersectionObserver — purely progressive enhancement.

export default function siteHeader() {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    if (typeof IntersectionObserver === 'undefined') return;

    const header = document.querySelector('.site-header');
    if (!header) return;

    const sentinel = document.createElement('div');
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.style.position = 'absolute';
    sentinel.style.top = '1px';
    sentinel.style.left = '0';
    sentinel.style.width = '1px';
    sentinel.style.height = '1px';
    sentinel.style.pointerEvents = 'none';
    document.body.prepend(sentinel);

    const observer = new IntersectionObserver(
        ([entry]) => {
            header.classList.toggle('is-scrolled', !entry.isIntersecting);
        },
        { rootMargin: '0px' }
    );
    observer.observe(sentinel);
}
